import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { useEffect, useMemo, useReducer, useRef, useState } from "react";
import { MdOutlineEdit } from "react-icons/md";
import Button from "../../Components/Button";
import Dialog from "../../Components/Modal/Dialog";
import CreateCustomer from "../CustomerGrid/CreateCustomer";
import EditCustomer from "./EditCustomer";
import PositionCodeAsign, { CONTEXT } from "../../Components/PositionCodeAsign";
import PencilIcon from "../../Assests/Icons/PencilIcon";
import AddUserIcon from "../../Assests/Icons/AddUserIcon";
import {
  fetchCustomers,
  getSalesPersonAdditionalDetailsV2,
  uploadCustomerToPositionCode,
} from "../../Services/Dashboard/tableGridService";
import classes from './CustomerGrid.module.css';
import { CUSTOMER_SEARCH_REDUCER } from "../../Utils/customer-search-reducer";
import { CustomerSearchActionTypes } from "../../Utils/constants";
import SearchWithControls from "../../Components/SearchWithControls";
import FileUploader from "../../Components/FileUploader";
import papa from "papaparse";
import useBulkUploadCustomers from "../../hooks/useBulkUploadCustomers";
import BulkUploadErrorModal from "../../Components/BulkUploadErrorModal/index"
import Loader from "../../Components/Loader";


export const RecordsPerPage = 1000;
export const EDIT_ICON = "editIcon";
export const CREATE_CUSTOMER = 'CREATE_CUSTOMER';
export const EDIT_CUSTOMER = 'EDIT_CUSTOMER';

const CustomerGrid = () => {
  const [data, setData] = useState([]);
  const [isPrevious, setIsPrevious] = useState(false);
  const [isNext, setIsNext] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [offset, setOffSet] = useState(RecordsPerPage);
  const [isShowCreateCustomerModal, setIsShowCreateCustomerModal] =
    useState(false);
  const [isShowEditCustomerModal, setIsShowEditCustomerModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isShowPositionCodeDetailsModal, setIsShowPositionCodeDetailsModal] =
    useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [editCustomerData, setEditCustomerData] = useState([]);
  const [newSalePerson, setNewSalesPerson] = useState(null);
  const [positionCodeData, setPositionCodeData] = useState([]);
  const [popupName, setPopupName] = useState('');
  const [createCustomerFormData, setCreateCustomerFormData] = useState(null);
  const [customerSearchState, customerSearchDispach] = useReducer(
    CUSTOMER_SEARCH_REDUCER,
    { searchValue: "", searchByValue: "userId", status: null }
  );
  const {
    data: customerData,
    isLoading: customerBulkuploadLoading,
    bulkUploadCustomers,
  } = useBulkUploadCustomers();

  const [showBulkUploadErrorModal, setShowBulkUploadErrorModal] = useState(false);
  const [bulkUploadResponse, setBulkUploadResponse] = useState({});
  const columnDefs = useMemo(
    () => [
      {
        field: "id",
        headerCheckboxSelection: true,
        checkboxSelection: true,
        showDisabledCheckboxes: true,
        headerName: "S No",
      },
      {
        field: EDIT_ICON,
        headerName: "",
        cellRenderer: () => {
          return (
            <div className="flex items-center justify-center h-full">
              <MdOutlineEdit
              onClick={() => {
                setPopupName(EDIT_CUSTOMER);
                setIsShowEditCustomerModal(true);
              }}
              style={{ color: "#47B7CF", fontSize: "large", cursor: "pointer" }}
            />
            </div>
          );
        },
        width: 60,
      },
      { field: "customerName", headerName: "Name" },
      { field: "customerUserId", headerName: "User ID" },
      { field: "positionCode" },
      { field: "Market" },
      { field: "Category" },
      { field: "Context" },
      { field: "Transfer ID" },
      { field: "salesPersonUserId", headerName: "CH ID" },
      { field: "salesPersonName", headerName: "CH Name" },
    ],
    []
  );

  const defaultColDef = useMemo(
    () => ({
      filter: true,
      sortable: true,
    }),
    []
  );

  const onCellClicked = (e) => {
    // on Edit Icon Click
    if (e?.colDef?.field === EDIT_ICON) {
      setEditCustomerData([e?.data]);
    }
  };

  const fetchCustomersListRef = useRef(() => {});
  const pageNumberRef = useRef(pageNumber);
  pageNumberRef.current = pageNumber;

  useEffect(() => {
    fetchCustomersListRef.current();
  }, [pageNumber]);

  useEffect(() => {
    if (
      customerSearchState.status === CustomerSearchActionTypes.SEARCH ||
      customerSearchState.status === CustomerSearchActionTypes.RESET
    ) {
      fetchCustomersListRef.current();
    }
  }, [customerSearchState.status]);

  const fetchCustomersList = () => {
    setIsLoading(true);
    setIsPrevious(pageNumber > 0);
    const body = {
      input: {
        limit: RecordsPerPage,
        offset: offset * pageNumber,
      },
    };
    const { searchValue, searchByValue } = customerSearchState;
    const trimmedValue = searchValue?.toString()?.trim();
    if (searchByValue === 'userId' && trimmedValue) {
      body.input.customerUserId = customerSearchState.searchValue;
    } else if(trimmedValue) {
      body.input.salesPersonUserId = customerSearchState.searchValue;
    }
    fetchCustomers(body)
      .then((res) => {
        setIsLoading(false);
        const { data } = res || {};
        const { customerToPositionCodeDetails } = data || {};
        const obj = {};
        const result = customerToPositionCodeDetails.map((d) => {
          d.positionCodeDetails.forEach((pcd) => {
            obj.positionCode = pcd.id;
            obj.provider = pcd.provider;
            pcd.positionCodeAdditionalDetails.forEach((pcda) => {
              obj[pcda.refType] = pcda.refValue;
            });
          });
          return {
            ...d,
            ...obj,
          };
        });
       popupName && setPopupName('');
        setIsNext(result?.length === RecordsPerPage);
        setData(result);
      })
      .catch((e) => {
        setIsLoading(false);
        throw e;
      });
  };
  fetchCustomersListRef.current = fetchCustomersList;
  const onNext = () => {
    setPageNumber((previous) => previous + 1);
    setData([]);
  };

  const onPrevious = () => {
    pageNumber && setPageNumber((previous) => previous - 1);
    offset && setOffSet((previous) => previous - RecordsPerPage);
    setData([]);
  };
  const onCloseEditCustomer = () => {
    setIsShowEditCustomerModal(false);
  };
  const onCloseCreateCustomer = () => {
    setIsShowCreateCustomerModal(false);
  };
  const createCustomerFn = async (event) => {
    setPositionCodeData([]);
    const {chData, customerData} = event;
    if (!chData || !customerData) {
      return;
    }
    setCreateCustomerFormData(event);
    try {
      const res = await getPositionCodeDetails(chData?.id);
      if (res?.data?.data) {
        onCloseCreateCustomer();
        setPositionCodeData(res?.data?.data);
        setIsShowPositionCodeDetailsModal(true);
      }
    } catch (e) {
      throw e;
    }
  }; 
  const editCustomerFn = async () => {
    setPositionCodeData([]);
    if (newSalePerson?.id) {
      setIsLoading(true);
      try {
        const res = await getPositionCodeDetails(newSalePerson?.id);
        setIsLoading(false);
        const { data } = res;
        if (data.data) {
          onCloseEditCustomer();
          setPositionCodeData(data.data);
          setIsShowPositionCodeDetailsModal(true);
        }
      } catch (e) {
        setIsLoading(false);
      }
    }
  };

  const handleRowSelection = (event) => {
    const selectedNodes = event.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    setSelectedRows(selectedData);
  };

  const onClosePositionCodeAsignModal = () => {
    setIsShowPositionCodeDetailsModal(false);
  };
  const findByRefType = (data, refType) => {
    return (
      data?.positionCodeAdditionalDetails?.find(
        (pcad) => pcad.refType === refType
      ) || {}
    );
  };

  const onAsignPositionCodeExistingUserFn = async (selectedRadioOptionId) => {
    if (!positionCodeData?.length || !selectedRadioOptionId) {
      return;
    }
    setIsLoading(true);
    const pcData =
      positionCodeData.find((pcd) => String(pcd.id) === String(selectedRadioOptionId)) || {};

    const input = editCustomerData.map((ecd) => {
      const customer = data.find((item) => item.id === ecd.id);
      return {
        userId: customer.customerUserId,
        realmId: customer.realmId,
        provider: customer.provider,
        context: customer.context,
        assignmentMode: customer.assignmentMode,
        positionCodeId: customer.positionCode,
        deleted: "1",
        customerToPositionCodeTimelineAdditionalDetails: [
          {
            refType: "CH_ID",
            refValue: ecd.salesPersonUserId,
          },
        ],
      };
    });
    input.push(
      ...editCustomerData.map((ecd) => {
        const customer = data.find((item) => item.id === ecd.id);
        return {
          userId: customer.customerUserId,
          realmId: customer.realmId,
          provider: customer.provider,
          context: findByRefType(pcData, CONTEXT)?.refValue,
          assignmentMode: customer.assignmentMode,
          positionCodeId: pcData.positionCodeId,
          customerToPositionCodeTimelineAdditionalDetails: [
            {
              refType: "CH_ID",
              refValue: newSalePerson?.chId,
            },
          ],
        };
      })
    );
    const body = {
      input,
    };
    try {
      const res = await uploadCustomerToPositionCode(body);
      if (res.status === 200) {
        setIsLoading(false);
        setData([]);
        setEditCustomerData([]);
        setSelectedRows([]);
        setNewSalesPerson(null);
        fetchCustomersList();
        onClosePositionCodeAsignModal();
      }
    } catch (e) {
      setIsLoading(false);
      throw e;
    }
  };

  const getSelectedChFn = (data) => {
    setNewSalesPerson(data);
  };

  const bulkEditFn = () => {
    setPopupName(EDIT_CUSTOMER);
    setEditCustomerData(selectedRows);
    setIsShowEditCustomerModal(true);
  };
  const getPositionCodeDetails = (salesPersonId) => {
    const body = {
      input: {
        salesPersonId,
        fetchPositionCodeAdditionalDetails: true,
        fetchSalesPersonToPositionCodeTimeline: false,
      },
    };
    return getSalesPersonAdditionalDetailsV2(body);
  }

  const onAddNewUserBtnClick = () => {
    setPopupName(CREATE_CUSTOMER);
    setIsShowCreateCustomerModal(true);
  }
  const onAsignPositionCodeForNewUserFn = async (selectedRadioOptionId) => {
    if (!positionCodeData?.length || !selectedRadioOptionId) {
      return;
    }
    setIsLoading(true);
    const pcData =
      positionCodeData.find((pcd) => String(pcd.id) === String(selectedRadioOptionId)) || {};
    const {chData, customerData} = createCustomerFormData;
    const obj =  {
          userId: customerData.asgardId,
          realmId: customerData.realmId,
          provider: 'Ninjacart',
          context: findByRefType(pcData, CONTEXT)?.refValue,
          assignmentMode: 'Manual',
          positionCodeId: pcData.positionCodeId,
          customerToPositionCodeTimelineAdditionalDetails: [
            {
              refType: "CH_ID",
              refValue: chData?.chId,
            },
          ],
        }
    const body = {
      input: [obj],
    };
    try {
      const res = await uploadCustomerToPositionCode(body);
      if (res.status === 200) {
        setIsLoading(false);
        setData([]);
        setEditCustomerData([]);
        setSelectedRows([]);
        fetchCustomersList();
        onClosePositionCodeAsignModal();
      }
    } catch (e) {
      setIsLoading(false);
      throw e;
    }
  }

  const onAsignPositionCodeFn = (selectedRadioOptionId) => {
    if (popupName === EDIT_CUSTOMER) {
      onAsignPositionCodeExistingUserFn(selectedRadioOptionId);
    } else {
      onAsignPositionCodeForNewUserFn(selectedRadioOptionId);
    }
  }
  const onSearchInputChange = (event) => {
    customerSearchDispach({
      type: CustomerSearchActionTypes.SET_SEARCH_VALUE,
      payload: {searchValue: event?.target?.value, status: CustomerSearchActionTypes.VALUE_UPDATE},
    });
  }
  const onSearchByChange = (event) => {
    customerSearchDispach({
      type: CustomerSearchActionTypes.SET_SEARCH_BY_VALUE,
      payload: {searchByValue: event?.target?.value, status: CustomerSearchActionTypes.VALUE_UPDATE},
    });
  }

  const onSearchCustomers  = () => {
   if (customerSearchState.status !== CustomerSearchActionTypes.SEARCH) {
    setData([]);
    setPageNumber(0);
    customerSearchDispach({
      type: CustomerSearchActionTypes.SET_STATUS,
      payload: {status: CustomerSearchActionTypes.SEARCH},
    });
   }
  }
  const onClearSearch = () => {
    if (customerSearchState.status !== CustomerSearchActionTypes.RESET) {
      setData([]);
      setPageNumber(0);
      customerSearchDispach({type: CustomerSearchActionTypes.RESET});
    }
  }

  const handleFile = (file) => {
    if (!file) {
      return;
    }
    papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        const {data} = results || {};
        const transformedResults = data?.map((customer) => {
          return {
            positionCodeId: customer?.Position_Code,
            userId: customer?.UserId,
            customerToPositionCodeTimelineAdditionalDetails: [
              {
                refType: 'CH_Id',
                refValue: customer?.SalesPerson_UserId,
              },
            ],
          };
        }) || [];
        setShowBulkUploadErrorModal(true);
        bulkUploadCustomers(transformedResults);
      },
    });
  };

  useEffect(() => {
    if (customerData?.data) {
      const { data } = customerData?.data || {};
      const successRows = data?.filter(item => item?.success);
      const failedRows = data
        ?.filter((item) => !item?.success)
        ?.map((item, index) => ({
          __uploadNumber: index + 1,
          overallValidationErrorMessage: item?.errorMessage,
          ...item,
        }));
      setBulkUploadResponse({successRows,failedRows});
      if (successRows?.length) {
        setData([]);
        if (pageNumberRef.current) {
          setPageNumber(0);
        } else {
          fetchCustomersListRef.current();
        }
      }
    }
  }, [customerData?.data]);


  const onCloseBulkUploadModal = () => {
    setShowBulkUploadErrorModal(false);
    setBulkUploadResponse({});
  };

  return (
    <>
      {isLoading && <Loader/>}
      <p className="flex items-center justify-center mt-16 text-lg text-[#0e76a8]"><b>Customers</b></p>
      <div
        className={`${classes["display-center"]} ${classes["action-btns-wrapper"]}`}
      >
        <SearchWithControls
          customerSearchState={customerSearchState}
          onSearchInputChange={onSearchInputChange}
          onSearchByChange={onSearchByChange}
          onSearchCustomers={onSearchCustomers}
          onClearSearch={onClearSearch}
          dropdownData={[
            { value: "userId", label: "User ID" },
            { value: "salesPersonUserId", label: "Sales Person User ID" },
          ]}
        />
        <div className={`${classes["display-center"]}`}>
          {selectedRows?.length > 1 && (
            <Button
              className={`${classes["display-center"]} ${classes["mr-10"]}`}
              onClick={bulkEditFn}
            >
              <PencilIcon />
              <span style={{ marginLeft: ".5rem" }}>Edit</span>
            </Button>
          )}
          <Button
            className={`${classes["display-center"]} ${classes["mr-10"]}`}
            onClick={onAddNewUserBtnClick}
          >
            <AddUserIcon />
            <span style={{ marginLeft: ".5rem" }}> Add New User</span>
          </Button>
          <FileUploader
              handleFile={handleFile}
            />
        </div>
      </div>
      <div className="ag-theme-alpine" style={{ height: "calc(100vh - 220px" }}>
        <AgGridReact
          onCellClicked={(e) => onCellClicked(e)}
          rowData={data}
          columnDefs={columnDefs}
          rowSelection="multiple"
          animaterowData={true}
          suppressPaginationPanel={true}
          overlayNoRowsTemplate={`<span style="padding: 10px; border: var(--ag-borders) var(--ag-border-color); background: var(--ag-background-color); border-radius: var(--ag-card-radius); box-shadow: var(--ag-card-shadow);padding: var(--ag-grid-size); ">${
            !isLoading ? "" : "No Data"
          }</span>`}
          suppressScrollOnNewData={true}
          defaultColDef={defaultColDef}
          onSelectionChanged={handleRowSelection}
        />
        <div
          className="flex items-center justify-center mt-3"
        >
          <Button
            disabled={!isPrevious || isLoading}
            onClick={() => onPrevious()}
          >
            Previous
          </Button>
          <p className="mx-2">Page: {pageNumber + 1}</p>
          <Button
            disabled={!isNext || isLoading}
            onClick={() => onNext()}
          >
            Next
          </Button>
        </div>
      </div>
      {isShowCreateCustomerModal && (
        <Dialog
          title="Create Customer"
          style={{ background: "rgba(241, 255, 253, 0.80)" }}
          onClose={onCloseCreateCustomer}
        >
          <CreateCustomer
            createCustomerFn={createCustomerFn}
            isLoading={isLoading}
          />
        </Dialog>
      )}
      {isShowEditCustomerModal && (
        <Dialog
          title="Edit Customer"
          style={{ background: "rgba(241, 255, 253, 0.80)" }}
          onClose={onCloseEditCustomer}
        >
          <EditCustomer
            editCustomerData={editCustomerData}
            editCustomerFn={editCustomerFn}
            getSelectedChFn={getSelectedChFn}
            isLoading={isLoading}
          />
        </Dialog>
      )}
      {isShowPositionCodeDetailsModal && (
        <Dialog
          title="Position Code Details"
          style={{ background: "rgba(241, 255, 253, 0.80)" }}
          onClose={onClosePositionCodeAsignModal}
        >
          <PositionCodeAsign
            positionCodeData={positionCodeData}
            onAsignPositionCodeFn={onAsignPositionCodeFn}
            isLoading={isLoading}
          />
        </Dialog>
      )}
      {showBulkUploadErrorModal && (
        <BulkUploadErrorModal
          isLoading={customerBulkuploadLoading}
          closeModal={onCloseBulkUploadModal}
          successRows={bulkUploadResponse?.successRows}
          failedRows={bulkUploadResponse?.failedRows}
        />
      )}
    </>
  );
};

export default CustomerGrid;
